import type { EntityType } from 'types/entityType';

export const ENTITY_TYPE: EntityType = 'pilot';

export const TEST_ID = 'pilotMultiSelectPanelField';
